import { CartItem } from "components/UI/molecules";
import "./index.scss";

export const CartItemList = ({ cards, deliveryType, ...props }) => {
  return (
    <div className="cart-item-list">
      {cards.map((itemProps) => (
        <CartItem
          key={itemProps.uuid}
          deliveryType={deliveryType}
          {...props}
          {...itemProps}
        />
      ))}
    </div>
  );
};
